import initQrPopup from 'components/qr-popup'
import { initForm } from 'landings/__assets__/scripts/components/form-handling'
import initExitPopup from 'landings/__assets__/scripts/components/exit-popup'
import { handleFormToggle } from '../js/components/toggleCalc'

initQrPopup()
initForm()
initExitPopup()
handleFormToggle()
